// Copy of error codes from /backend/src/Exception/InvalidRequestException.php

export const errorCodes = {
  REQUIRED_FIELD: 10,
  FILL_DATERANGE: 20,
  STARTING_DATE_AFTER_ENDING_DATE: 21,
  REQUEST_DATE_AFTER_STARTING_DATE: 22,
  CHOSE_ROOM: 30,
  FORMAT_PHONE_NUMBER: 40,
  PASSWORD_OLD_NEW_DIFFERENT: 50,
  BAD_PASSWORD_PATTERN: 60,
  FILL_TRAVELLERS: 70,
  FORMAT_EMAIL: 80,
  AT_LEAT_ONE_PHONE_NUMBER: 90,
  FILL_BED_TYPE: 100,
  EXISTING_EMAIL: 110,
  BAD_DOMAIN_PATTERN: 120,
  NO_USER_NO_EMAIL_COPY: 130,
  BAD_FAVORITE_LOCATION: 200,
  BAD_FAVORITE_HOTEL: 210
}
